import * as React from "react";
import Autocomplete, {
  AutocompleteProps,
  AutocompleteRenderInputParams,
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { SvgIcon } from "../../../components/SvgIcon";
import {
  TextField,
  MenuList,
  MenuItem,Box, makeStyles,
} from "@material-ui/core";
import { tl } from "../../../utils";
import Tag from "../students/components/Tag";
import {Value} from "@material-ui/lab/useAutocomplete/useAutocomplete";
import { KeyboardArrowDownRounded } from "@material-ui/icons";

export interface ISelectOption {
  id: string,
  name: string,
}

const useStyles = makeStyles(() => ({
  end: {
    paddingRight: 8,
  }
}))

interface DropdownSelectProps extends Omit<AutocompleteProps<ISelectOption, true, false, true>, 'renderInput'|'value' >{
  onValueCancel?: (option: ISelectOption) => void;
  canCreateNew?: boolean;
  renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode;
  value?: Value<ISelectOption|number, true, false, true>;
}

const filter = createFilterOptions<ISelectOption>({
  stringify: (option) => option.name
});

export const DropdownSelect = ({onValueCancel, canCreateNew, ...props}: DropdownSelectProps) => {
  const classes = useStyles();

  return (
    <Autocomplete
      noOptionsText={tl("Совпадений не найдено")}
      popupIcon={<KeyboardArrowDownRounded />}
      renderInput={(params) => <TextField variant="outlined" {...params} />}
      getOptionLabel={(option: ISelectOption) => option.name}
      renderTags={(value: Array<ISelectOption>, _getTagProps) => {
        return value.map(tag=>
          tag ? (
            <Box m={'2px'} key={tag.id + 'tagAutoComplete'} display="flex" alignItems="center" justifyContent="center">
              <Tag onCancel={onValueCancel ? () => onValueCancel(tag): undefined}>{tag.name}</Tag>
            </Box>
          ) : null
        )
      }}
      classes={{
        endAdornment: classes.end
      }}
      filterOptions={(options: ISelectOption[], state) => {
          const filtered = filter(options, state);

          if (state.inputValue !== "" && filtered.length === 0 && canCreateNew) {
            filtered.push({
              id: 'new',
              name: state.inputValue,
            })
          }

          return filtered;
      }}
      ListboxComponent={MenuList}
      renderOption={(option: ISelectOption, { selected }) => (
        <MenuItem
          component="div"
          selected={selected}
          placeholder={props.placeholder}
        >

          {option.id === 'new' ? `${tl('Новый тег:')}: ${option.name}` : option.name}
        </MenuItem>
      )}
      {...props}
    />
  );
};
